import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import AddVenta from "../components/AddVenta";
import AppVentaReactTable from "../table/AppVentaReactTable";
import "../css/admin.css";

const Ventas = () => {
  const [usuario, setUsuario] = useState({});
  const [show, setShow] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode = jwt_decode(token);
        setUsuario(token_decode.usuario || {});
      } catch (e) {
        console.error("❌ Error al decodificar token:", e);
        setUsuario({});
      }
    }
  }, [token]);

  const puedeVerVentas = [
    "ROOT_ROLE",
    "ADMIN_ROLE",
    "MANAGER_ROLE",
    "VENDEDOR_ROLE",
  ].includes(usuario?.role);

  const esVendedor = usuario?.role === "VENDEDOR_ROLE";

  return (
    <>
      <div className="cabecera">
        {token ? (
          <div className="container mt-5">
            {puedeVerVentas ? (
              <>
                <h3 className="mt-3 mb-2">GESTIÓN DE VENTAS</h3>

                {esVendedor && (
                  <div className="alert alert-light border small mb-3">
                    Perfil vendedor: se muestran únicamente tus ventas.
                  </div>
                )}

                <hr />

                <div className="mt-3 mb-3">
                  <AddVenta setShow={setShow} show={show} />
                </div>

                <div className="mt-3 mb-3">
                  {!show && <AppVentaReactTable />}
                </div>
              </>
            ) : (
              <div className="alert alert-info" role="alert">
                Lo sentimos, pero no tiene permisos para acceder a este contenido.
              </div>
            )}
          </div>
        ) : (
          <div className="container mt-5">
            <div className="alert alert-danger" role="alert">
              No se encuentra logueado en la plataforma.
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Ventas;